
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/view-base/abpbase";
import { RoleDto, CreateUserInput } from "@/api/service-proxies";

import { userService } from "@/api/userService";

@Component({
  name: "select-record-face-templete",
  components: {},
})
export default class CreateNewUser extends Vue {
  isDialogVisible =false
  roles: RoleDto[] = [];
  checkList = [];
  item = new CreateUserInput({
    isEdcationUser : false
  });

  public open() {
    this.isDialogVisible=true;
  }
  //提交创建信息
  createUser(){
    userService.createUser(this.item)
    .then(()=>{
      this.$message.success("添加成功");
    })
    .catch((e)=>{
      this.$message.error("添加失败");
    })
  }

  created() {}

}
